<template>
  <div>
    <h5 class="mt-1 mb-2 font-weight-bold">
      <i class="fa fa-star mr-2 text-warning" aria-hidden="true" />Quick Access
    </h5>
    <hr class="mt-2 mb-2" />
    <div class="mb-5 mt-2" v-if="itemBookmarks.length != 0">
      <div v-if="itemBookmarks[0].menu.length != 0">
        <section>
          <div class="cards-wrapper">
            <div
              class="zoom-fav card animate__animated animate__flipInX"
              v-for="(book, index) in itemBookmarks[0].menu_detail"
              :key="`b` + index"
            >
              <b-link
                :href="book.link"
                target="_blank"
                class="text-center text-dark"
              >
                <b-img
                  v-show="book.icon !== null && book.icon !== 'null'"
                  :src="book.icon"
                  class="mt-3 mr-2"
                  width="30"
                  height="30"
                  alt="pic"
                ></b-img>
                <p class="mt-2 font-card f-sm-1">{{ book.name }}</p>
              </b-link>
            </div>
          </div>
        </section>
      </div>
      <div v-else>
        <p class="text-dark mt-2 mb-3">
          You can press the star
          <i class="fa fa-star mr-1 ml-1" aria-hidden="true" /> for the menu
          that you use most often.
        </p>
      </div>
    </div>
    <div v-else>
      <p class="text-dark Tab-font mt-2 mb-3">
        You can press the star
        <i class="fa fa-star mr-1 ml-1" aria-hidden="true" /> for the menu that
        you use most often.
      </p>
    </div>
    <b-tabs
      content-class="mt-5"
      active-nav-item-class="text-dark h5 font-weight-bold"
    >
      <b-tab @click="menuPortal('ANNOUNCEMENT')">
        <template v-slot:title>
          <b-link class="text-dark Tab-font active" variant="dark">
            <img
              src="@/assets/img/portal-anoun.png"
              class="mr-2"
              width="30"
              height="30"
              alt="announcement"
            />
            <span>ANNOUNCEMENT</span>
          </b-link>
        </template>
      </b-tab>
      <b-tab
        v-for="(catalog, index) in itemCatalog"
        :key="`ca` + index"
        @click="menuPortal(catalog.id)"
      >
        <template v-slot:title>
          <b-link
            :ref="catalog.id"
            class="text-dark Tab-font"
            :class="{ active: active_el == catalog.id }"
            variant="dark"
          >
            <b-img
              v-show="catalog.icon !== null && catalog.icon !== 'null'"
              :src="catalog.icon"
              class="mr-2"
              width="30"
              height="30"
              alt="pic"
            ></b-img>
            <span>{{ catalog.name }}</span>
          </b-link>
        </template>
      </b-tab>
    </b-tabs>
    <div v-if="loading">
      <b-button class="mt-3 Tab-font ml-3" variant="primary" disabled>
        <b-spinner style="width: 3rem; height: 3rem" type="grow"></b-spinner>
        <p class="mt-2">Loading...</p>
      </b-button>
    </div>
    <div v-else>
      <div v-if="anounmentView">
        <div v-for="(anounment, index) in itemAnounment" :key="'A' + index">
          <b-card v-if="anounment.show" class="card-announ mt-4">
            <b-card-title>
              <b-media>
                <template v-slot:aside>
                  <img
                    src="@/assets/img/iconA.png"
                    class="mt-1"
                    width="64"
                    height="64"
                    alt="icon"
                  />
                </template>
                <h5 class="ml-2 mt-2 mb-0 f-500 font-anount">
                  <u>{{ anounment.topic }}</u>
                </h5>
                <em class="ml-2 font-anoun-footer-1 mt-0 font-anount">
                  Update : {{ moment(anounment.updated_at).format("LLLL") }}
                </em>
              </b-media>
            </b-card-title>
            <hr class="mt-2 mb-2" />
            <b-card-body>
              <b-card-text class="mt-2 mb-3">
                <p class="mt-2 mb-2">
                  <span v-html="anounment.detail"></span>
                </p>
              </b-card-text>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <div v-else>
        <div class="mt-4 row">
          <div
            v-for="(item, index) in itemMenu"
            :key="`menu` + index"
            class="zoom-app"
            :class="{
              'col-md-3': MaxScale === 'Monitor',
              'col-md-4': MaxScale === 'miniMonitor',
            }"
          >
            <b-card
              v-if="item.show"
              class="card-app mt-3 mb-2 animate__animated animate__flipInX"
            >
              <b-card-title class="h4">
                <div class="d-flex w-100 justify-content-between">
                  <b-link
                    :href="item.link"
                    target="_blank"
                    class="font-card-head color-head-f"
                    >{{ item.name }}</b-link
                  >
                  <b-link
                    @click="bookmark(item.id)"
                    class="font-card-head text-secondary"
                  >
                    <i
                      v-if="itemBookmarks.length != 0"
                      :class="{
                        'text-warning': itemBookmarks[0].menu.includes(item.id),
                      }"
                      class="fa fa-star"
                      aria-hidden="true"
                    />
                    <i v-else class="fa fa-star" aria-hidden="true" />
                  </b-link>
                </div>
              </b-card-title>
              <hr class="mt-1" />
              <div class="mt-3 text-center">
                <b-link :href="item.link" target="_blank">
                  <b-img
                    v-if="item.icon !== null && item.icon !== 'null'"
                    :src="item.icon"
                    class="mr-2"
                    width="64"
                    height="64"
                    :alt="item.icon"
                  ></b-img>
                  <b-img
                    v-else
                    blank
                    blank-color="#ccc"
                    width="64"
                    alt="placeholder"
                  ></b-img>
                </b-link>
              </div>
              <b-card-text>
                <div class="mt-3 alert-height">
                  <p
                    class="text-dark mb-2 font-card-detail"
                    v-html="item.detail"
                  ></p>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    MaxScale: String,
  },
  data() {
    return {
      loading: false,
      itemCatalog: [],
      itemMenu: [],
      active_el: 0,
      itemAnounment: [],
      anounmentView: false,
      itemBookmarks: [],
    };
  },
  computed: {},
  mounted() {
    this.setUpmethos();
    this.menuPortal("ANNOUNCEMENT");
  },
  methods: {
    async setUpmethos() {
      this.itemCatalog = [];
      this.itemBookmarks = [];
      const fetchBooking = await this.$http.get(`/portal/bookmark/`);
      const fetchCatalog = await this.$http.get(`/portal/catalog/`);
      Promise.all([fetchBooking, fetchCatalog])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listBookmark, catalog]) => {
          this.itemCatalog = catalog.map((item) => {
            return {
              id: item.id,
              name: item.name,
              icon: item.icon,
            };
          });
          this.itemBookmarks = listBookmark.map((item) => {
            return {
              id: item.id,
              menu_detail: item.menu_detail,
              menu: item.menu,
            };
          });
          // console.log(listBookmark)
          // console.log(catalog)
        })
        .catch((e) => {
          console.log("caught");
        });
    },
    async catalogPortal() {
      this.itemCatalog = [];
      try {
        const res = await this.$http.get(`/portal/catalog/`);
        if (res.status === 200) {
          // console.log(res.data)
          this.itemCatalog = res.data.map((item) => {
            return {
              id: item.id,
              name: item.name,
              icon: item.icon,
            };
          });
        }
      } catch (error) {}
    },
    delayedShow(serie, idx) {
      let delay = 150 * idx;
      setTimeout(() => {
        serie.show = true;
      }, delay);
    },
    async menuPortal(menuSelected) {
      this.anounmentView = false;
      this.loading = true;
      this.itemMenu = [];
      try {
        setTimeout(() => (this.loading = false), 300);
        if (menuSelected === "ANNOUNCEMENT") {
          this.anounmentView = true;
          this.getAnounment();
        } else {
          this.anounmentView = false;
          this.active_el = menuSelected;
          var url = `/portal/menu/?catalog=${menuSelected}`;
          const res = await this.$http.get(url);
          if (res.status === 200) {
            this.itemMenu = res.data.map((item) => {
              return {
                id: item.id,
                catalog_detail: item.catalog_detail,
                icon: item.icon,
                name: item.name,
                detail: item.detail,
                link: item.link,
                catalog: item.catalog,
                show: false,
              };
            });
            // delay
            this.itemMenu.forEach((serie, idx) => {
              this.delayedShow(serie, idx);
            });
          } else {
            throw { res };
          }
        }
      } catch (error) {
        this.loading = false;
        this.$router.push("/portal").catch((err) => {});
      }
    },
    async getAnounment() {
      this.itemAnounment = [];
      try {
        const res = await this.$http.get(`/portal/announcement/`);
        if (res.status === 200) {
          this.itemAnounment = res.data.map((item) => {
            return {
              id: item.id,
              topic: item.topic,
              detail: item.detail,
              show_start: item.show_start,
              show_end: item.show_end,
              created_at: item.created_at,
              updated_at: item.updated_at,
              show: false,
            };
          });
          // delay
          this.itemAnounment.forEach((serie, idx) => {
            this.delayedShow(serie, idx);
          });
        }
      } catch (error) {}
    },
    async getBookmark() {
      this.itemBookmarks = [];
      try {
        const res = await this.$http.get(`/portal/bookmark/`);
        if (res.status === 200) {
          this.itemBookmarks = res.data.map((item) => {
            return {
              id: item.id,
              menu_detail: item.menu_detail,
              menu: item.menu,
            };
          });
        }
      } catch (error) {}
    },
    async bookmark(idMenu) {
      const sendDataListBookmark = new FormData();
      if (this.itemBookmarks.length == 0) {
        sendDataListBookmark.append("menu", idMenu);
      } else {
        if (this.itemBookmarks[0].menu.includes(idMenu)) {
          // found : delete
          for (let a = 0; a < this.itemBookmarks[0].menu.length; a++) {
            if (this.itemBookmarks[0].menu[a] != idMenu) {
              sendDataListBookmark.append(
                "menu",
                this.itemBookmarks[0].menu[a]
              );
            }
          }
        } else {
          // not found : add
          for (let a = 0; a < this.itemBookmarks[0].menu.length; a++) {
            sendDataListBookmark.append("menu", this.itemBookmarks[0].menu[a]);
          }
          sendDataListBookmark.append("menu", idMenu);
        }
      }
      try {
        const response = await this.$http.post(
          "/portal/bookmark/update_menu/",
          sendDataListBookmark,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 200) {
          this.itemBookmarks = [];
          this.itemBookmarks.push(response.data);
          // this.getBookmark()
        } else {
          throw { response };
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.card-app {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px;
}
.zoom-app {
  transition: transform 0.2s; /* Animation */
}
.zoom-app:hover {
  transform: scale(1.1);
}
.zoom-fav {
  transition: transform 0.2s; /* Animation */
}
.zoom-fav:hover {
  transform: scale(1);
}
// { font-family: 'Baloo Tamma 2', cursive; }
.nav-font {
  font-family: "Varela Round", sans-serif;
}
.Tab-font {
  font-family: "Kanit", sans-serif;
  font-weight: 100;
}
.font-card {
  font-family: "Kanit", sans-serif;
  font-weight: 100;
}
.font-card-head {
  font-family: "Baloo Tamma 2", cursive;
}
.color-head-f {
  color: #452b73;
  font-weight: 700;
}
.font-card-detail {
  font-family: "Kanit", sans-serif;
  font-size: 0.85rem;
}
.font-card-link {
  font-family: "Baloo Tamma 2", cursive;
}
.alert-height {
  height: 130px;
}
.f-sm-1 {
  font-size: 0.85rem;
}
// .head-height{ height: 285px; }
//
.a-announce {
  color: #1b1e21;
  background-color: #fbf6f6;
  border-color: #ffffff00;
  padding: 17px;
  border-radius: 20px;
}
.font-anount {
  font-family: "Baloo Tamma 2", cursive;
}
.card-announ {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  // border-radius: 20px;
}
.bg-light-custom {
  background-color: #ffffff !important;
}
.font-anoun-detail {
  font-family: "Baloo Tamma 2", cursive !important;
}
.font-anoun-footer {
  font-size: 0.7rem;
}
.font-anoun-footer-1 {
  font-size: 1rem;
}
.text-purple {
  color: #452b73;
}
//
:root {
  --page-margin: min(2rem, 5vw);
  color: #444;
}
section {
  display: grid;
  grid-template-columns: var(--page-margin) [center-start] 1fr [center-end] var(
      --page-margin
    );
  & > * {
    grid-column: center;
  }
}
.cards-wrapper {
  grid-column: center-start / -1;
  overflow: auto;
  display: flex;
  padding-bottom: 0em;
  .card {
    background-color: #fff5b2;
    color: #31312f;
    height: 7em;
    min-width: 8em;
    margin-right: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    &:last-child {
      margin-right: 0;
    }
  }
  &::after {
    content: "";
    display: block;
    min-width: var(--page-margin);
  }
}
</style>